import { mapGetters, mapState } from 'vuex'
export default {
    data() {
        return {
            currencyFilter: null,
            selectedBankId: '',
            form: {
                amount: null,
            },
            amount: '',
        }
    },
    computed: {
        ...mapGetters({
            getCurrencyByType: 'finance/getCurrencyByType',
            bankAccount: 'themes/player-bank/bankAccount',
            getExchangeRateByFromAndTo:
                'themes/settings/getExchangeRateByFromAndTo',
            getCurrencyColor: 'finance/getCurrencyColor',
            getCurrencySymbol: 'finance/getCurrencySymbol',
        }),
        ...mapState({
            getPlayerBankAccountLoading: (state) =>
                state.themes['player-bank'].getPlayerBankAccountLoading,
            getCurrencyLoading: (state) => state.finance.getCurrencyLoading,
        }),
        playerCurrencyCookie() {
            return this.$cookie.get('player')?.currency
        },
        currencyList() {
            return this.getCurrencyByType(1)
        },
        bankAccountByFilter() {
            if (!this.currencyFilter) return this.bankAccount
            const playerBankAccounts =
                this.bankAccount?.player_bank_accounts?.filter(
                    (el) => el.currency === this.currencyFilter
                )

            return {
                ...this.bankAccount,
                player_bank_accounts: playerBankAccounts,
            }
        },
        // Just to know which player-bank-accounts currency has been selecting
        selectedBankCurrency() {
            const selectedBankAccount =
                this.bankAccount.player_bank_accounts?.find(
                    (el) => el.id === this.selectedBankId
                )
            if (!selectedBankAccount) return null
            return selectedBankAccount.currency
        },
        // To get a currency color, to display the color for the Player Bank Account Border
        selectedCurrencyColor() {
            if (!this.currencyFilter) return null
            return this.getCurrencyByType(1)?.find(
                (el) => el.code === this.currencyFilter
            )?.color
        },
        withdrawalExchangeRate() {
            return this.getExchangeRateByFromAndTo(
                this.playerCurrencyCookie,
                this.currencyFilter
            )
        },
        withdrawalReceivingAmount() {
            if (!this.withdrawalExchangeRate) return this.form.amount
            return this.withdrawalExchangeRate * this.form.amount
        },
        displayBankLoadingCard() {
            if (this.getPlayerBankAccountLoading === null) return true
            if (
                !this.bankAccount?.player_bank_accounts?.length &&
                this.getPlayerBankAccountLoading
            )
                return true
            return false
        },
    },
    watch: {
        currencyList(value) {
            if (this.currencyFilter || !value || !value?.length) return
            this.currencyFilter = value[0]?.code
        },
        bankAccountByFilter(value) {
            this.setDefaultBankAccount()
        },
    },
    mounted() {
        this.setDefaultBankAccount()
        // check if the currency list is exist, then set the first currency as default selectedBankCurrency
        if (this.currencyList?.length) {
            this.currencyFilter = this.currencyList[0]?.code
        }
    },
    methods: {
        setDefaultBankAccount() {
            // Retrieve the list of player bank accounts from the filtered data.
            const accounts = this.bankAccountByFilter?.player_bank_accounts

            // If there are no bank accounts available, reset the selectedBankId and exit.
            if (!accounts?.length || !accounts) {
                this.selectedBankId = ''
                return
            }

            // If a bank account is already selected (selectedBankId is set),
            // check if it exists in the current list of accounts.
            // If it exists, no further action is needed, so exit.
            if (this.selectedBankId) {
                if (accounts?.find((el) => el.id === this.selectedBankId))
                    return
            }

            // Attempt to find a primary bank account from the list.
            const primaryAccount = accounts?.find(
                (account) => account.is_primary === true
            )

            // If a primary account exists, set it as the selected bank account.
            // Otherwise, default to the first account in the list.
            if (primaryAccount) {
                this.selectedBankId = primaryAccount.id
            } else {
                this.selectedBankId = accounts[0]?.id
            }
        },
        onWithdrawalAmountInput(withdrawalAmount) {
            if (isNaN(withdrawalAmount?.replace(/,/g, ''))) {
                this.form.amount = '0'
                return
            }
            this.amount = withdrawalAmount
                ? Number.parseFloat(
                      withdrawalAmount?.replace(/,/g, '')
                  )?.toLocaleString()
                : ''
            this.form.amount = this.amount?.toString()?.replace(/,/g, '')
        },
        onSelectedBankAccount(id) {
            if (this.selectedBankId === id) {
                // This case is to remove the selected bank-account-card
                // this.selectedBankId = null
            } else {
                this.selectedBankId = id
            }
        },
    },
}
